import i18next from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

i18next
  .use(
    resourcesToBackend((lng, ns, callback) => {
        import(`../../../../localization/locales/${lng}/${ns}.json`)
        .then((resources) => callback(null, resources))
        .catch((e) => callback(e, null));
    })
  )
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en-us',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      console.warn(`Missing key: ${key}`);
      return fallbackValue;
    },
  });

export default i18next;
